import React from 'react';

export default (rmsById, flowsById, productsById, descriptorsById) =>  [
  {
    title: 'ID',
    field: 'id',
    minWidth: 50,
  },
  {
    title: 'Codigo',
    field: 'code',
    minWidth: 100,
  },
  {
    title: 'MP',
    field: 'substance_id',
    minWidth: 50,
    render: rowData => rowData.substance_id ?
      rmsById[rowData.substance_id].name : ''
  },
  {
    title: 'Produto',
    field: 'product_id',
    minWidth: 50,
    render: rowData => rowData.product_id ?
      productsById[rowData.product_id].code + ' ' + productsById[rowData.product_id].name : ''
  },
  {
    title: 'Fluxo',
    field: 'flow_id',
    minWidth: 50,
    render: rowData => rowData.flow_id ?
      flowsById[rowData.flow_id].code + ' ' + flowsById[rowData.flow_id].name : ''
  },
  {
    title: 'raw_material_supplier_id',
    field: 'raw_material_supplier_id',
    minWidth: 50,
  },
  {
    title: 'lcs_id',
    field: 'lcs_id',
    minWidth: 50,
    render: rowData => rowData.lcs_id ?
      descriptorsById[rowData.lcs_id].code + ' ' + descriptorsById[rowData.lcs_id].description : ''
  },
  {
    title: 'Tipo',
    field: 'type',
    minWidth: 50,
  },
  {
    title: 'Designacao',
    field: 'designation',
    minWidth: 200,
  },
  {
    title: 'Notas',
    field: 'notes',
    minWidth: 200,
  },
];
